<template>


<div id="weekly-releases-section" class="container-fluid releases no-gutters">
  <div class="container-fluid container-weekly">

        <div  class="row flowplayereleases" id="releases-ax" v-for="(cat,ic) in $parent.lang.movies" v-if="cat.movies.length > 0 && ic == 'free' " v-bind:key="cat.genre">
           <!-- <h3 class="nrlslstxt text-center w-100" v-html="cat.genre"></h3> -->
              <div
                  v-observe-visibility="{
        callback: visibilityChanged,
        throttle,
        intersection: {
          threshold,
        },
      }"
                  v-scroll="handleScroll"
                  v-for="(movie,mic) in filterSlider(cat.movies)"
                  :key="mic"
                  :id="movie.slug"
                  :ref="movie.slug"

                  :title="movie.title"
                  :alt="movie.title"
                  :class="'special-banner col-12 '+movie.type" :x-style="'background: url('+$parent.img(movie.promo_background)+');'">
                <div class="blackplace text-center">
                  <img v-lazyload width="350" height="136" :src="$parent.img('https://flximg.flixlatinogo.com/loadingph.png')" :data-src="$parent.img(movie.promo_logo)" :alt="movie.title" >


                  <div class="container rela">
                    <ul class="nav nav-pills  align-items-center justify-content-center">
                      <li class="nav-item m1" v-if="movie.tv_rate">
                        <a class="nav-link">{{ movie.tv_rate }}</a>
                      </li>

                      <li class="nav-item m1">
                        <a class="nav-link active">{{ movie.country }}</a>
                      </li>
                       <li class="nav-item m1">
                        <a class="nav-link text-capitalize">{{ movie.type }}</a>
                      </li>
                       <li class="nav-item m1">
                        <a class="nav-link">{{ movie.genres[0].genre }}</a>
                      </li>

                    </ul>

                    <p class="shortdesc">
                      {{ movie.synopsis }}
                    </p>

                    <a @click="$parent.playBlackVideo(movie)"  class="btn btn-danger btn-flg glow m1">{{ $parent.lang.playnow}}</a>
                    <a @click="$parent.playBlackTrailer(movie)"  class="btn btn-outline-danger btn-flg glow m1">{{ $parent.lang.playTrailer}}</a>

                    <p>
                      <br>
                      <strong>Director: </strong>
                      <template v-for="(dir,dirin) in movie.directors"> {{dir.name}} <template v-if="dirin < (movie.directors.length - 1)">,</template><template v-else>.</template> </template>
                      <br>
                      <strong>Casting: </strong>
                      {{movie.casting.lastIndex}}
                      <template v-for="(cast, castindex) in movie.casting"> {{cast.name}} <template v-if="castindex < (movie.casting.length - 1)">,</template><template v-else>.</template> </template>
                    </p>

                  </div>
                  
                </div>
              </div>

        </div>

    </div>
  </div>


</template>


<script>




export default {
  name: 'flixSample',
  components: {
  },
  data(){ return {
      timer: null,
      prevPos: 0,
      direction: "even"
    }
  },
  created: function () {

    // this.lang = lang.es;
    // this.movies = lang.movies;
    
  },
  updated: function(){
    // this.profiling();
    this.fillScrollElements()
  },
  computed:{

    scrollElements: function() {
      let elems = []
      var i = 0
      Object.keys(this.$refs).forEach(el => {
        elems[i] = this.$refs[el][0]
        i++
      });
      return elems
    }

  },
  
  methods:{
    visibilityChanged: function(isVisible, entry) {
      if(isVisible){
        let style = entry.target.getAttribute("x-style");
        entry.target.setAttribute("style",style);
      }else{
        entry.target.setAttribute("style","");
      }
    },
    hasPromo: function(movie){
      return (movie.promo_logo && movie.promo_background ? movie : null)
    },
    filterSlider: function(movies){
      return movies.filter(this.hasPromo)
    },
    handleScroll: function() {
      // if (this.$parent.isMobile){
      //   if (window.scrollY > this.prevPos){
      //     this.direction = "up"
      //   }else if (window.scrollY < this.prevPos){
      //     this.direction = "down"
      //   }else if (window.scrollY == this.prevPos){
      //     this.direction = "even"
      //   }
      //
      //
      //   let nextElement =  this.nextElement((window.scrollY - window.innerHeight), this.direction)
      //
      //
      //
      //   if (nextElement && this.direction != "even"  && window.scrollY > (window.innerHeight / 2)) {
      //
      //     clearTimeout(this.timer)
      //     this.timer = setTimeout(()=>{
      //       location.hash = "#"+nextElement.id
      //       // window.scrollTo({
      //       //   top: nextElement.offsetTop + window.innerHeight,
      //       //   left: 0,
      //       //   behavior: 'smooth'
      //       // });
      //       clearTimeout(this.timer)
      //       setTimeout(()=>{clearTimeout(this.timer)},410)
      //
      //     },400)
      //   }else{
      //     // clearTimeout(this.timer)
      //     // setTimeout(()=>{clearTimeout(this.timer);console.log("clear timer")},50)
      //   }
      //
      //   this.prevPos = window.scrollY
      //
      // }
    },
    fillScrollElements: function(){
      this.scrollElements = []
      Object.keys(this.$refs).forEach(el => {
        this.scrollElements.push(this.$refs[el][0].offsetTop)
      });
    },
    nextElement: function(t,dir){
      let result = this.scrollElements.filter(obj => {
        window._el = obj
        let ans = null
        switch (dir) {
          case "up":
            // ans = obj.offsetTop > t
            ans = null
            break;
          case "down":
            ans = obj.offsetTop < t
            break;
          case "even":
          default:

            ans = null
            break;

        }
        return ans
      })
      let first;
      switch (dir) {
        case "up":
          first = result.find((e)=>{return e})
          break;
        case "down":
          result.shift()
          first = result.find((e)=>{return e}) // last
          break;
        default:

          break;

      }

      return (first ? first : null);

    }

    

  }

}
</script>
